var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputValue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_26290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7664 19.4954C26.427 19.4954 26.152 19.7704 26.152 20.1097V25.5643C26.1508 26.5818 25.3265 27.4063 24.3091 27.4073H7.07164C6.05416 27.4063 5.22986 26.5818 5.22866 25.5643V9.55553C5.22986 8.53829 6.05416 7.71374 7.07164 7.71254H12.5262C12.8655 7.71254 13.1405 7.43754 13.1405 7.09821C13.1405 6.75913 12.8655 6.48389 12.5262 6.48389H7.07164C5.376 6.48581 4.00192 7.85989 4 9.55553V25.5645C4.00192 27.2602 5.376 28.6343 7.07164 28.6362H24.3091C26.0047 28.6343 27.3788 27.2602 27.3807 25.5645V20.1097C27.3807 19.7704 27.1057 19.4954 26.7664 19.4954Z",
    fill: "#fff",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1375 4.90299C26.0578 3.82335 24.3075 3.82335 23.2278 4.90299L12.2678 15.863C12.1927 15.9381 12.1385 16.0312 12.1102 16.1334L10.6689 21.3367C10.6096 21.5501 10.6699 21.7785 10.8263 21.9352C10.983 22.0917 11.2115 22.1519 11.4248 22.0929L16.6281 20.6514C16.7304 20.6231 16.8235 20.5688 16.8986 20.4937L27.8583 9.53348C28.9363 8.45313 28.9363 6.70421 27.8583 5.62386L27.1375 4.90299ZM13.6064 16.2623L22.5763 7.29215L25.4692 10.185L16.499 19.1552L13.6064 16.2623ZM13.0285 17.4218L15.3397 19.7332L12.1428 20.619L13.0285 17.4218ZM26.9896 8.66478L26.3381 9.31631L23.445 6.42321L24.0968 5.77168C24.6965 5.17199 25.6688 5.17199 26.2685 5.77168L26.9896 6.49256C27.5884 7.09297 27.5884 8.06462 26.9896 8.66478Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_26290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6667,
    height: 24.6667,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputValue);
export default __webpack_public_path__ + "static/media/InputValue.a2b3dcb7cd8a1dcd452f6c408b00478b.svg";
export { ForwardRef as ReactComponent };